<template>
	<c-dialog ref="dialog" enable-flex mode="slide" mask-close @close="closeHandle" @resolve="submitHandle">
		<c-tips>单个业务的视图最多可创建{{systemConfig.vip_view_count}}个</c-tips>
		<c-tab-list ref="tabList" :tabs="tabList" type="border-tab" @change="data => currentTab = data.value"></c-tab-list>
		<c-form v-show="currentTab == 1" ref="base" unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="视图名称" required>
				<c-input name="view_name"></c-input>
			</c-form-item>
			<c-form-item label="视图说明">
				<c-input type="textarea" name="remark" maxlength="200"></c-input>
			</c-form-item>
			<c-form-item label="图标颜色">
				<ul class="icon flex-wrap">
					<li v-for="(item, i) in iconColor" :key="i" class="flex-center" :class="{'z-crt': item == currentIconColor}" @click="currentIconColor = item; $refs.base.setEditState(true);">
						<i class="tf" :style="{'color': item != 'default' ? `var(--color-${item})` : '#333'}">&#xe63b;</i>
					</li>
				</ul>
			</c-form-item>
			<c-form-item label="二级分组">
				<c-select name="second_group_field_id" :options="groupOptions"></c-select>
			</c-form-item>
			<!-- 可见部门/可见用户逻辑注释停用
			<c-form-item label="可见部门">
				<c-select ref="departmentSelector" class="flex-grow" name="department_ids" async :multiple="{linefeed: true}" @search="searchDepartment"></c-select>
			</c-form-item>
			<c-form-item label="可见用户" tip="可见部门和可见用户都不选择表示所有人可见">
				<c-select ref="userSelector" class="flex-grow" name="user_ids" async :multiple="{linefeed: true}" @search="searchUser"></c-select>
			</c-form-item>
			-->
			<c-form-item label="可见版本" tip="不选择表示不限版本">
				<c-checkbox-group name="version_ids" :options="versionOptions"></c-checkbox-group>
			</c-form-item>
			<c-form-item label="可见权限" tip="不选择表示所有数据权限范围的用户可见">
				<c-checkbox-group name="data_scopes" :options="dataScopeDic"></c-checkbox-group>
			</c-form-item>
		</c-form>

		<field-config v-show="currentTab == 2" ref="fieldConfig" class="flex-grow flex-column" style="margin: 20px;"></field-config>

		<data-filter v-show="currentTab == 3" ref="dataFilter" class="flex-grow" style="overflow: auto;"></data-filter>

		<data-sort v-show="currentTab == 4" ref="dataSort" class="flex-grow" style="overflow: auto;"></data-sort>
	</c-dialog>
</template>

<script>
	import fieldConfig from './field_config.vue'
	import dataFilter from './data_filter.vue'
	import dataSort from './data_sort.vue'
	import {mapState, mapGetters} from 'vuex'

	export default {
		components: {
			fieldConfig,
			dataFilter,
			dataSort
		},

		props: {
			workType: [String, Number],
			dynamicField: Boolean,
			fieldSort: Boolean
		},

		data() {
			return {
				currentTab: 1,
				iconColor: ['default', 'main', 'blue', 'yellow', 'red','green'],
				currentIconColor: 'default',
				groupOptions: [],
				versionOptions: [],

				filterKey: 0,
				filterField: [],
				filterList: [],
				disabledFilterField: []
			}
		},

		computed: {
			...mapState(['systemConfig', 'dataScopeDic']),

			tabList() {
				let list = [{
					name: '基本信息',
					value: 1
				}, {
					name: '数据过滤',
					value: 3
				}];

				if (!this.dynamicField) {
					list.splice(1, 0, {
						name: '字段配置',
						value: 2
					});
				}

				if (this.fieldSort) {
					list.push({
						name: '默认排序',
						value: 4
					});
				}

				return list;
			}
		},

		methods: {
			async open(id, copy) {
				this._editState = !copy && !!id;
				this.$refs.tabList.changeIndex(0);
				this.currentIconColor = this.iconColor[0];
				this.$refs.base.clear();
				this.groupOptions = [];
				this.versionOptions = [];
				this.filterList = [];
				this.request({
					url: '/sys_user_view/manage/info',
					data: {
						work_type_id: this.workType,
						view_id: id
					},
					loading: true,
					success: data => {
						if (data.view_info) {
							if (copy) {
								delete data.view_info.id;
								data.view_info.view_name += '-复制'
							}
							this.currentIconColor = data.view_info.icon || this.iconColor[0];
							data.view_info.second_group_field_id = data.view_info.second_group_field_id || '';
							this.$refs.base.set(Object.assign(data.view_info, {
								//可见部门/可见用户逻辑注释停用
								//department_ids: data.auth_department_list.map(item => item.id),
								//user_ids: data.auth_user_list.map(item => item.id),
								version_ids: data.auth_version_list || [],
								data_scopes: data.auth_data_scope_list || []
							}));
							//可见部门/可见用户逻辑注释停用
							//this.$refs.departmentSelector.setValueData(data.auth_department_list.map(item => {
							//	return {
							//		name: item.department_name,
							//		value: item.id
							//	}
							//}));
							//this.$refs.userSelector.setValueData(data.auth_user_list.map(item => {
							//	return {
							//		name: item.user_realname,
							//		value: item.id
							//	}
							//}));
						}
						if (!this.dynamicField) {
							this._lastFieldList = data.field_list.filter(item => item.is_enable == 1).map(item => {
								return `${item.field_id}-${item.is_lock}${item.is_display}`;
							}).join('|');
							this.$refs.fieldConfig.set(data.field_list);
						}
						this.$refs.dataFilter.set(this.workType, data.view_info ? data.view_info.filter_condition || [] : [])
						this.$refs.dataSort.set(this.workType, data.view_info ? data.view_info.sort_config || [] : [])
						this.$refs.dialog.open({
							title: copy ? '复制视图' : id ? '编辑视图' : '创建视图'
						});
					}
				});

				//查询可用版本列表（可见版本配置项）
				this.searchVersion();

				this.request({
					url: '/sys_user_view/second_group_field_list',
					data: {
						work_type_id: this.workType
					},
					success: data => {
						this.groupOptions = data.map(item => {
							return {
								name: item.field_title,
								value: item.id
							}
						})
					}
				});
			},

			//可见部门/可见用户逻辑注释停用
			//searchDepartment(keyword, resolve) {
			//	this.request({
			//		url: '/system/options',
			//		data: {
			//			options_code: 'DEPARTMENT',
			//			keyword
			//		},
			//		success: data => {
			//			resolve(data);
			//		}
			//	})
			//},

			//searchUser(keyword, resolve) {
			//	this.request({
			//		url: '/system/options',
			//		data: {
			//			options_code: 'SYSUSER',
			//			keyword
			//		},
			//		success: data => {
			//			resolve(data);
			//		}
			//	})
			//},

			searchVersion() {
				this.request({
					url: '/sys_saas/version/list',
					success: data => {
						//可见版本排除API版（版本编码已统一为后端 EditionVersionCodeEnum 口径的 API，
						this.versionOptions = data.filter(item => !['API'].includes(item.version_code)).map(item => {
							return {
								name: item.version_name,
								value: item.id
							}
						})
					}
				});
			},

			async submitHandle(stop, next) {
				stop();
				let fieldList;
				let syncFieldList = 2;
				if (!this.dynamicField) {
					fieldList = this.$refs.fieldConfig.get();
					if (this._editState && this._lastFieldList != fieldList.map(item => {
						return `${item.field_id}-${item.is_lock}${item.is_display}`;
					}).join('|')) {
						if (await this.$confirm({
							title: '您已修改了视图，是否同步给所有人',
							message: '同步视图后，所有人将共享视图的配置',
							buttonName: '同步',
							cancelButtonName: '不同步'
						}) == 'resolve') {
							syncFieldList = 1;
						}
					}
				}
				this.$refs.base.submit({
					url: this._editState ? '/sys_user_view/edit' : '/sys_user_view/add',
					rule: {
						view_name: {
							check: '请填写视图名称',
							fail: () => {
								this.$refs.tabList.changeIndex(0);
							}
						}
					},
					dataFormatter: data => {
						data.work_type_id = this.workType;
						data.icon = this.currentIconColor;
						data.field_list = fieldList;
						data.is_sync = syncFieldList;
						data.filter_condition = this.$refs.dataFilter.get();
						data.sort_config = this.$refs.dataSort.get();
						return data;
					},
					success: data => {
						this.$message({
							message: '提交成功'
						});
						this.$emit('update', data.id);
						next();
					}
				})
			},

			closeHandle() {
				this.dialogFormEditConfirm({
					editState: this.$refs.base.editState || this.$refs.fieldConfig.editState || this.$refs.dataFilter.$refs.form.editState || this.$refs.dataSort.$refs.form.editState
				}, arguments);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.icon {
		gap: 8px;
		padding: 4px 0;

		li {
			box-sizing: border-box;
			width: 30px;
			height: 30px;
			border-radius: 4px;
			font-size: 18px;
			cursor: pointer;

			&:hover {
				font-size: 20px;
			}

			&.z-crt {
				border: 1px solid var(--color-main);
				font-size: 20px;
			}
		}
	}
</style>
